// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"4d0436f9","453":"612f53fa"}[chunkId] + ".chunk.js";
};